import styled, { css } from 'styled-components';

export const FilterSportsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin-top: 20px;
    padding-top: 15px;
    justify-content: space-around;
  }
  font-family: ${props => props.theme.fontSets.narrow};
  white-space:nowrap;
`;

export const WrapperAll = styled.div`
  cursor: pointer;
  margin: 0 0.8em 0 0.5em;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin: 0px;
  }
  font-family: ${props => props.theme.fontSets.narrowMedium};
  font-size:16px;
  
   > div:hover {
    color: ${props => props.theme.colors.selectedColor};
   }
`;
export const RightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-left: 0.1em;
  position: relative;
  ${(process.env.REACT_APP_SITE !== 'fcinter' && process.env.REACT_APP_SITE !== 'calcionapoli1926' && process.env.REACT_APP_SITE !== 'forzaroma') && css`
    border-left: 1px solid ${props => props.theme.colors.gray};
  `};
  ${props => props.theme.mediaQueries.tablet_big_down}{
    border-left: none; 
  }
`;
